import styled from "@emotion/styled"

const Content = styled('div')(() => ({
    height: 'auto',
    width:'100%',
    top:'100px',
    display: 'flex',
    alignItems: 'center',
    flexDirection:'column',
}))

export default Content